import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { inboundConsolidationRouteEndpointSchema } from "./inbound-consolidation-address";
import { InboundConsolidationDisplayStatuses } from "./inbound-consolidation-lifecycle";

const inboundConsolidationSummarySchema_ = z.object({
  id: z.string(),
  reference: z.string(),
  status: createEnum(InboundConsolidationDisplayStatuses, {
    enumName: "InboundConsolidationLifecycleStatus",
  }),
  itemCount: z.number(),
  origin: inboundConsolidationRouteEndpointSchema,
  destination: inboundConsolidationRouteEndpointSchema,
  carrier: z.string().nullable(),
  trackingCode: z.string().nullable(),
  trackingUrl: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const inboundConsolidationSummarySchema: z.ZodType<InboundConsolidationSummary> =
  inboundConsolidationSummarySchema_;
export interface InboundConsolidationSummary extends z.infer<
  typeof inboundConsolidationSummarySchema_
> {}

export const listInboundConsolidations = unaryRpc({
  name: "listInboundConsolidations" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    statuses: z
      .array(
        createEnum(InboundConsolidationDisplayStatuses, {
          enumName: "InboundConsolidationLifecycleStatus",
        }),
      )
      .optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(200).default(25),
  }),
  output: z.object({
    items: z.array(inboundConsolidationSummarySchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});

export type ListInboundConsolidationsOutput = z.infer<
  (typeof listInboundConsolidations)["output"]
>;

export { InboundConsolidationDisplayStatuses };
